import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import { Flex, Box } from 'grid-styled';
import { ThemeProvider } from 'styled-components';
import connect from '../store/connect';
import Page from './Page';
import { fetchArticlePageView } from '../actions/actionCreators';
import { color, size } from '../styles/helpers/variables';
import { StartPageBlock } from '../styles/blocks/StartPageBlock';
import { SITE_ROOT_URL } from '../constants/endpoints';
import LinedHeading from '../components/LinedHeading';
import { NavigationButton } from '../components/NavigationButton';
import LargeNavigationButton from '../components/LargeNavigationButton';
// import DesignerCard from '../components/DesignerCard';
import AboutCard from '../components/AboutCard';
import HeroSection from '../components/StartPage/HeroSection';
import InstagramSection from '../components/InstagramSection';
import { InfoBanner } from '../components/InfoBanner';
import { Conditional } from '../components/Conditional';
import { InformationCards } from '../components/InformationCards';
import ProductList from '../components/ProductList';

class StartPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popularCategoriesNumber: props.viewstate.get('pageWidth') > size.xLarge ? 3 : 0
    };
  }
  componentDidMount() {
    this.props.fetchArticlePageView({ urlPath: this.props.location.pathname });
  }
  componentWillReceiveProps(nextProps) {
    this.setState(() => ({
      popularCategoriesNumber: nextProps.viewstate.get('pageWidth') > size.xLarge ? 3 : 0
    }));
  }

  renderLargePopularCategories() {
    return this.props.startPage
      .getIn(['fields', 'categoryLinks'], List())
      .take(this.state.popularCategoriesNumber)
      .map(category => (
        <Box
          key={category.get('systemId')}
          width={[1, 1, 1, 1 / 3, 1 / 3]}
          py={['5px', '8px', '11px']}
          px={['0px', '8px', '11px']}
        >
          <LargeNavigationButton
            image={SITE_ROOT_URL + category.getIn(['images', 0, 'url'])}
            title={category.get('name')}
            url={category.get('url')}
          />
        </Box>
      ))
      .toArray();
  }

  renderSmallPopularCategories() {
    return this.props.startPage
      .getIn(['fields', 'categoryLinks'], List())
      .slice(this.state.popularCategoriesNumber, 6 + this.state.popularCategoriesNumber)
      .map(category => (
        <Box
          key={category.get('systemId')}
          width={[1, 1, 1 / 2, 1 / 2, 1 / 3]}
          py={['5px', '8px', '11px']}
          px={['0px', '8px', '11px']}
        >
          <NavigationButton
            image={category.getIn(['images', 0, 'url'])}
            title={category.get('name')}
            url={category.get('url')}
          />
        </Box>
      ))
      .toArray();
  }

  render() {
    const { startPage, viewstate } = this.props;

    const startPageFields = startPage.get('fields', Map());
    const largePopularCategoriesList = this.renderLargePopularCategories();
    const smallPopularCategoriesList = this.renderSmallPopularCategories();

    let popularProducts = startPageFields.get('popularProducts');
    if (popularProducts) {
      if (viewstate.get('pageWidth') >= 850 && viewstate.get('pageWidth') < 1100 && popularProducts.size === 4) {
        popularProducts = popularProducts.slice(0, 3);
      }
      popularProducts = popularProducts.toMap().mapEntries(entry => {
        const newEntry = entry;
        newEntry[0] = entry[1].get('id');
        return newEntry;
      });
    }

    return (
      <Page meta={startPage.get('metaData')} bgColor="white" noBreadcrumbs>
        {/* hero section */}
        <HeroSection
          backgroundColor={startPageFields.get('heroBackgroundColor', color.grey)}
          heroImage={
            startPageFields.getIn(['heroImage', 'url'])
              ? SITE_ROOT_URL + startPageFields.getIn(['heroImage', 'url'])
              : null
          }
          heroBackgroundIsLight={startPageFields.get('heroBackgroundIsLight')}
          heroTitle={startPageFields.get('heroTitle')}
          heroLinkUrl={startPageFields.get('heroLinkUrl')}
          heroLinkLabel={startPageFields.get('heroLinkLabel')}
          alignRight={startPageFields.get('heroBoxPosition')}
          isMobile={viewstate.get('pageWidth') < size.large}
        />

        {viewstate.get('pageWidth') >= size.large && (
          <Fragment>
            {/* information card section */}
            <InformationCards
              cards={startPageFields.get('informationCardLinks')}
              py={20}
              mb={
                !(
                  !!startPageFields.get('infoBannerBackgroundColor') &&
                  !!startPageFields.get('infoBannerHeadline') &&
                  !!startPageFields.get('infoBannerText')
                )
                  ? -50
                  : 0
              }
            />

            {/* info banner section */}
            <Conditional
              show={
                !!startPageFields.get('infoBannerBackgroundColor') &&
                !!startPageFields.get('infoBannerHeadline') &&
                !!startPageFields.get('infoBannerText')
              }
            >
              <StartPageBlock.Section backgroundColor={color.lightGrey} py={0}>
                <StartPageBlock.Container>
                  <InfoBanner
                    backgroundColor={startPageFields.get('infoBannerBackgroundColor')}
                    headline={startPageFields.get('infoBannerHeadline')}
                    text={startPageFields.get('infoBannerText')}
                    linkText={startPageFields.get('infoBannerLinkText')}
                    linkUrl={startPageFields.get('infoBannerLinkUrl')}
                  />
                </StartPageBlock.Container>
              </StartPageBlock.Section>
            </Conditional>
          </Fragment>
        )}

        {viewstate.get('pageWidth') >= size.large && popularProducts && (
          <StartPageBlock.Section
            backgroundColor={color.lightGrey}
            pt={viewstate.get('pageWidth') <= size.large ? 1 : 35}
          >
            <StartPageBlock.Container bgColor={color.lightGrey}>
              <LinedHeading>{startPageFields.get('popularProductsSectionHeadline', '')}</LinedHeading>
              <ProductList data={popularProducts} />
            </StartPageBlock.Container>
          </StartPageBlock.Section>
        )}

        {/* popular categories section */}
        <StartPageBlock.Section
          backgroundColor={color.lightGrey}
          pt={viewstate.get('pageWidth') <= size.large ? 10 : 35}
        >
          <StartPageBlock.Container bgColor={color.lightGrey}>
            <LinedHeading>{startPageFields.get('categorySectionHeadline', '')}</LinedHeading>
            <ThemeProvider
              theme={{
                breakpoints: ['500px', '730px', '800px', '1200px']
              }}
            >
              <Flex flexWrap="wrap" mx={['0px', '-8px', '-11px']}>
                {this.props.viewstate.get('pageWidth') > size.xLarge
                  ? largePopularCategoriesList
                  : smallPopularCategoriesList}
              </Flex>
            </ThemeProvider>
            {this.props.viewstate.get('pageWidth') > size.xLarge && (
              <ThemeProvider
                theme={{
                  breakpoints: ['500px', '730px', '800px', '1200px']
                }}
              >
                <Flex flexWrap="wrap" mx={['0px', '-8px', '-11px']}>
                  {smallPopularCategoriesList}
                </Flex>
              </ThemeProvider>
            )}
          </StartPageBlock.Container>
        </StartPageBlock.Section>

        {viewstate.get('pageWidth') < size.large && (
          <Fragment>
            {/* info banner section */}
            <Conditional
              show={
                !!startPageFields.get('infoBannerBackgroundColor') &&
                !!startPageFields.get('infoBannerHeadline') &&
                !!startPageFields.get('infoBannerText')
              }
            >
              <StartPageBlock.Section backgroundColor={color.lightGrey}>
                <StartPageBlock.Container>
                  <InfoBanner
                    backgroundColor={startPageFields.get('infoBannerBackgroundColor')}
                    headline={startPageFields.get('infoBannerHeadline')}
                    text={startPageFields.get('infoBannerText')}
                    linkText={startPageFields.get('infoBannerLinkText')}
                    linkUrl={startPageFields.get('infoBannerLinkUrl')}
                  />
                </StartPageBlock.Container>
              </StartPageBlock.Section>
            </Conditional>

            {/* information card section */}
            <InformationCards
              headline="Nyheter och erbjudanden"
              cards={startPageFields.get('informationCardLinks')}
              py={1}
            />
          </Fragment>
        )}

        {viewstate.get('pageWidth') < size.large && popularProducts && (
          <StartPageBlock.Section
            backgroundColor={color.lightGrey}
            pt={viewstate.get('pageWidth') <= size.large ? 1 : 35}
          >
            <StartPageBlock.Container bgColor={color.lightGrey}>
              <LinedHeading>{startPageFields.get('popularProductsSectionHeadline', '')}</LinedHeading>
              <ProductList data={popularProducts} />
            </StartPageBlock.Container>
          </StartPageBlock.Section>
        )}

        {/* designer section */}
        {/* <StartPageBlock.Section
          backgroundColor={color.lightGrey}
          pt={viewstate.get('pageWidth') <= size.large ? 10 : 20}
          pb={viewstate.get('pageWidth') <= size.large ? 52 : 93}
        >
          <StartPageBlock.Container bgColor={color.lightGrey}>
            <LinedHeading>{startPageFields.get('designerSectionHeadline', '')}</LinedHeading>
            <DesignerCard
              id={startPageFields.getIn(['designerLink', 'id'])}
              linkUrl={startPageFields.getIn(['designerLink', 'url'])}
              name={startPageFields.getIn(['designerLink', 'name'])}
              description={startPageFields.getIn(['designerLink', 'description'])}
              portrait={SITE_ROOT_URL + startPageFields.getIn(['designerLink', 'images', 0, 'url'])}
              image={
                startPageFields.getIn(['designerSectionImage', 'url'])
                  ? SITE_ROOT_URL + startPageFields.getIn(['designerSectionImage', 'url'])
                  : null
              }
            />
          </StartPageBlock.Container>
        </StartPageBlock.Section> */}

        {startPageFields.getIn(['aboutUsImage', 'url']) &&
          (startPageFields.get('aboutUsHeadline') || startPageFields.get('aboutUsText')) && (
            <StartPageBlock.Section
              backgroundColor={color.lightGrey}
              pt={viewstate.get('pageWidth') <= size.large ? 1 : 35}
              pb={viewstate.get('pageWidth') <= size.large ? 30 : 100}
            >
              <StartPageBlock.Container bgColor={color.lightGrey}>
                <LinedHeading>{startPageFields.get('aboutUsSectionHeading', '')}</LinedHeading>
                <AboutCard
                  imageUrl={startPageFields.getIn(['aboutUsImage', 'url'])}
                  imageAlt={startPageFields.getIn(['aboutUsImage', 'alt'])}
                  heading={startPageFields.get('aboutUsHeadline')}
                  body={startPageFields.get('aboutUsText')}
                  linkText={startPageFields.get('aboutUsLinkText')}
                  linkUrl={startPageFields.getIn(['aboutUsLink', 'url'])}
                  defaultLinkText={startPageFields.getIn(['aboutUsLink', 'name'])}
                />
              </StartPageBlock.Container>
            </StartPageBlock.Section>
          )}

        {/* instagram section */}
        <InstagramSection />
      </Page>
    );
  }
}

StartPage.defaultProps = {
  startPage: Map(),
  viewstate: Map()
};

StartPage.propTypes = {
  fetchArticlePageView: PropTypes.func.isRequired,
  startPage: PropTypes.instanceOf(Map),
  viewstate: PropTypes.instanceOf(Map),
  location: PropTypes.object.isRequired
};

export default connect(
  StartPage,
  { fetchArticlePageView },
  store => ({
    startPage: store.page.data.get('/'),
    viewstate: store.viewstate
  })
);



// WEBPACK FOOTER //
// ./src/pages/StartPage.js